// @flow

export const RATING_LABELS = [
  'JustDisaster',
  'VeryBad',
  'SoSo',
  'Good',
  'Excellent',
]
